import DashboardIcon from '@repo/ui/components/icons/sidebar/DashboardIcon';
import MaintenanceIcon from '@repo/ui/components/icons/sidebar/MaintanceIcon';
// import MessagesIcon from '@/components/icons/sidebar/messages';
import SupportIcon from '@repo/ui/components/icons/sidebar/ChatIcon';
import TwoUsersIcon from '@repo/ui/components/icons/sidebar/TwoUsersIcon';
import AddClient from '@repo/ui/components/icons/AddClient';
import UsersIcon from '@repo/ui/components/icons/sidebar/UsersIcon';
import LocationIcon from '@repo/ui/components/icons/sidebar/LocationIcon';
import People from '@repo/ui/components/icons/People';
import { BarChart3, CircleDollarSign, Package } from 'lucide-react';

export const navigationBottom = [
    // { name: 'messages', icon: MessagesIcon, activeIcon: MessagesIcon, to: '' },
    {
        name: 'settings',
        icon: MaintenanceIcon,
        activeIcon: MaintenanceIcon,
        to: '/settings',
        requiresPermission: 'list_setting',
    },
    // { name: 'help_and_support', icon: SupportIcon, activeIcon: SupportIcon, to: '' },
];

export const studentRelations = [
    {
        name: 'add_client',
        to: '/student-relations/add-student',
        requiresPermission: 'create_customer',
    },
    { name: 'student_communication', to: '/student-relations/student-communication' },
    // { name: 'archive', to: '/student-relations/archive' },
];

// // Service
export const ReportsSide = [
    { name: 'student', to: '/reports/student' },
    { name: 'marketing', to: '/reports/marketing' },
    {
        name: 'courses_and_products',
        to: '/reports/courses-and-products',
    },
    {
        name: 'branches_and_employees',
        to: '/reports/branches-and-employees',
    },
];

export const navigation = [
    { name: 'dashboard', icon: DashboardIcon, activeIcon: DashboardIcon, to: '/' },
    {
        name: 'student_relations',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        to: '/student-relations',
        navigation: studentRelations,
        requiresPermission: 'list_customer',
    },

    {
        name: 'service',
        icon: People,
        activeIcon: People,
        to: '/courses',
        requiresPermission: 'list_service',
    },
    {
        name: 'educational_products',
        icon: Package,
        activeIcon: Package,
        to: '/educational-products',
        requiresPermission: 'list_product',
    },
    {
        name: 'order',
        icon: AddClient,
        activeIcon: AddClient,
        to: '/orders',
        requiresPermission: 'list_order',
    },
    // {
    //     name: 'customer_by_type',
    //     icon: ShoppingCart,
    //     activeIcon: ShoppingCart,
    //     to: '/sales',
    //     requiresPermission: 'list_customer',
    // },
    {
        name: 'marketing',
        to: '/marketing',
        icon: TwoUsersIcon,
        activeIcon: TwoUsersIcon,
        requiresPermission: 'list_marketing',
    },
    {
        name: 'employees',
        icon: UsersIcon,
        activeIcon: UsersIcon,
        to: '/human-resources/employees',
        requiresPermission: 'list_user',
    },
    {
        name: 'branches',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/branches',
        requiresPermission: 'list_branch',
    },
    {
        name: 'finance',
        icon: CircleDollarSign,
        activeIcon: CircleDollarSign,
        to: '/finance',
        // requiresPermission: 'list_finance',
    },
    {
        name: 'reports',
        icon: BarChart3,
        activeIcon: BarChart3,
        to: '/reports',
        navigation: ReportsSide,
        requiresPermission: 'list_report',
    },
    {
        name: 'permissions',
        icon: LocationIcon,
        activeIcon: LocationIcon,
        to: '/permissions-page',
        requiresPermission: 'list_role',
    },

];
